import { api } from 'src/api/axios';

export const useDeleteAcrylicPlate = (id: number | string) => api.delete(`/api/cms/acrylic-plate/${id}`);
